import React, { ChangeEvent, DetailedHTMLProps, HTMLAttributes } from 'react';

import cn from 'classnames';
import './TextArea.scss';

export type TextAreaType = DetailedHTMLProps<
  HTMLAttributes<HTMLTextAreaElement>,
  HTMLTextAreaElement
> & {
  className?: string;
  error?: string;
  value?: string;
  onChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  rows?: number;
};

export const TextArea = ({
  value,
  onChange,
  error,
  className,
  label,
  placeholder,
  disabled,
  rows,
}: TextAreaType) => {
  const finalClassname = error
    ? 'TextareaForm__Textarea TextareaForm__Error'
    : 'TextareaForm__Textarea';

  return (
    <div className={cn('TextareaForm', className)}>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      {label && <label className="TextareaForm__Label">{label}</label>}
      <textarea
        value={value}
        onChange={onChange}
        className={finalClassname}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
      />
      {error && <span className="TextError">{error}</span>}
    </div>
  );
};
